import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProjectService } from '../services/project.service';
import { Note } from '../models/note';
import { image } from './image.const';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-screen3',
  templateUrl: './screen3.component.html',
  styleUrls: ['./screen3.component.scss'],
})
export class Screen3Component implements OnInit, OnDestroy {
  errorMessage: string = '';
  noteCollection: Note[] = [];
  imageSource: any;
  selectedImage: any = '';
  showImagePopup: boolean = false;
  showNewNoteInput: boolean = false;
  newNoteText: string = '';
  isSavingNote: boolean = false;

  selectedProjectSubscription: Subscription = {} as Subscription;
  notesDataSubscription: Subscription = {} as Subscription;

  constructor(
    private projectService: ProjectService,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.projectService.isHelpOverlayVisible = false;

    this.createNotes();

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:image/png;base64, ${image}`
    );
  }

  ngOnDestroy(): void {
    this.selectedProjectSubscription.unsubscribe();
    this.notesDataSubscription.unsubscribe();
  }

  createNotes() {
    // Data Subscriptions --------------------------------------------------------
    this.selectedProjectSubscription =
      this.projectService.selectedProject.subscribe(
        (data) => {
          this.noteCollection = [];
        },
        (error) => (this.errorMessage = error)
      );

    this.notesDataSubscription = this.projectService.notesData.subscribe(
      (data) => {
        if (data == null) {
          console.log('Error in Notes Comp: Notes data is null.');
          return;
        }

        if (data.length > 0) {
          this.noteCollection = data;
        } else {
          console.log('Notes Screen > No Notes');
        }
      }
    );
  }

  base64Sanitize(imageText: string | null): any {
    if (!imageText || imageText.length == 0) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `data:image/png;base64, ${image}`
      );
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `data:image/png;base64, ${imageText}`
      );
    }
  }

  showPopup(imageText: string) {
    this.selectedImage = imageText;
    this.showImagePopup = true;
  }

  closePopup() {
    this.showImagePopup = false;
  }

  addNewNote() {
    // Show the text input field
    this.showNewNoteInput = true;
    this.newNoteText = '';
    this.isSavingNote = false;
  }

  onEnterSaveNote(event: Event) {
    // Prevent default Enter key behavior and stop propagation
    event.preventDefault();
    event.stopPropagation();
    
    // Save the note
    this.saveNewNote();
  }

  onBlurSaveNote() {
    // Only save on blur if we're not already saving
    // This prevents double-save when Enter triggers both keydown and blur
    if (!this.isSavingNote) {
      this.saveNewNote();
    }
  }

  saveNewNote() {
    // Prevent multiple simultaneous saves
    if (this.isSavingNote) {
      console.log('Already saving note, skipping duplicate save...');
      return;
    }

    // Validate that user entered some text
    if (!this.newNoteText || this.newNoteText.trim() === '') {
      this.showNewNoteInput = false;
      this.isSavingNote = false;
      return;
    }

    // Set flag to prevent multiple saves
    this.isSavingNote = true;
    console.log('Starting to save note...');

    // Get the current project name
    const projectName = this.projectService.getProject();
    
    if (!projectName) {
      alert('No project selected. Please select a project first.');
      this.showNewNoteInput = false;
      this.isSavingNote = false;
      return;
    }

    // Create a new note with current timestamp
    const newNote: Note = {
      IM: null,
      TX: this.newNoteText.trim(),
      T: new Date()
    };

    // Add the new note to the existing collection
    const allNotes = [...this.noteCollection, newNote];

    // Prepare the API URL
    const apiUrl = `${environment.apiUrl}v1/projects/notes`;
    const params = new HttpParams().set('projectName', projectName);

    // Call the API with all notes
    console.log('Sending notes to API:', apiUrl);
    console.log('Project Name:', projectName);
    console.log('Payload:', allNotes);

    this.http.post(apiUrl, allNotes, { params }).subscribe(
      (response) => {
        console.log('Notes saved successfully:', response);
        // Update the notes data in the service to reflect the changes
        this.projectService.setNotesData(allNotes);
        // Reset the input
        this.showNewNoteInput = false;
        this.newNoteText = '';
        this.isSavingNote = false;
        console.log('Save complete, flag reset');
      },
      (error) => {
        console.error('Error saving notes:', error);
        alert('Failed to save note. Please try again.');
        this.showNewNoteInput = false;
        this.isSavingNote = false;
      }
    );
  }

  cancelNewNote() {
    this.showNewNoteInput = false;
    this.newNoteText = '';
    this.isSavingNote = false;
  }
}
